import { z } from 'zod';
import { CategoryEnum, UserResourceTypeEnum } from './enum';

export type UserResourceCreate = z.infer<typeof schemaUserResourceCreate>;
export const schemaUserResourceCreate = z.object({
  id: z.number().optional(),
  userResourceType: UserResourceTypeEnum,
  calendarId: z.string().nullable(),
  email: z.string().nullable(),
  category: CategoryEnum,
  isSelected: z.boolean(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  color: z.string(),
});

export type UserResourceCreateBody = z.infer<
  typeof schemaUserResourceCreateBody
>;
export const schemaUserResourceCreateBody = z.object({
  resources: z.array(schemaUserResourceCreate),
});

export type UserResourceListItem = z.infer<typeof schemaUserResourceListItem>;
export const schemaUserResourceListItem = z.object({
  id: z.number(),
  name: z.string(),
  isSelected: z.boolean(),
});

export type ResourceListItem = z.infer<typeof schemaResourceListItem>;
export const schemaResourceListItem = z.object({
  id: z.string().nullable(),
  name: z.string().nullable(),
  isSelected: z.boolean(),
  timeZone: z.string().nullable(),
  color: z.string(),
});
